module.exports = __webpack_public_path__ + "img/img4.8e0707a6.png";